<template>
  <main>
    <menus/>
    <div class="cont" v-show="ti==0">
      <div class="tops" >
        <span>待提现</span>
        <span>999</span>
        
      </div>
      <div class="tops">
        <span>已提现</span>
        <span>1999</span>
        <!-- <router-link :to="{name: 'tour_order_detail', query: { order_sn: s.row.order_sn }}">详情</router-link> -->
        <!-- <span class="tix" @click="tix">提现记录</span> -->
        <button class="tix" @click="tix">提现记录</button>
      </div>
      <div>

      </div>
      <nav>
        <span>订单状态：</span>
        <a :class="{ on: i === navIndex }" v-for="(v, i) in nav" :key="v.label" @click="changeNavIndex(i)">{{v.label}}</a>
      </nav>
      <el-table
        class="table"
        v-loading="loading"
        :data="list">
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="tour_sn" label="订单号"></el-table-column>
        <!-- <el-table-column label="使用范围"></el-table-column> -->
        <!-- <el-table-column label="订单金额">
          <template slot-scope="s">
            <span>{{s.row.departure_date | format}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="订单金额">
          <template slot-scope="s">
            <span class="price">{{s.row.total_amount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="下单时间">
          <template slot-scope="s">
            <span>{{s.row.created_at | format('MM-DD hh:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提成金额">
          <template slot-scope="s">
            <!-- <span class="price">{{s.row.total_amount-s.row.coupon_deduct_amount}}</span> -->
            <span class="price">{{s.row.total_amount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="s">
            <span class="paid">{{s.row.status_text}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="s">
            <!-- <router-link v-show="s.row.is_paid === 0" :to="{name: 'tour_pay', query: { orderNo: s.row.order_sn }}" class="pay_btn">支付</router-link> -->
            <!-- <router-link :to="{name: 'tour_order_detail', query: { order_sn: s.row.order_sn }}">详情</router-link> -->
            <el-popconfirm 
              class="delete"
              confirmButtonText='是的'
              cancelButtonText='不用了'
              icon="el-icon-info"
              iconColor="#66b1ff"
              title="确定提交审核吗？"
              @confirm="deleteAddress(s.row.id)">
              <el-button slot="reference" size="mini" type="primary">提交审核</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="search.page"
        @current-change="changePage"
        :hide-on-single-page="true"
        :total="total">
      </el-pagination>
    </div>



    <div class="cont" v-show="ti==1">
      <button class="tixian" @click="re">返回</button>
      <div class="ht">提现记录</div>
      <el-table
        class="table"
        v-loading="loading"
        :data="list">
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="tour_sn" label="订单号"></el-table-column>
        <!-- <el-table-column label="使用范围"></el-table-column> -->
        <!-- <el-table-column label="订单金额">
          <template slot-scope="s">
            <span>{{s.row.departure_date | format}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="订单金额">
          <template slot-scope="s">
            <span class="price">{{s.row.total_amount}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="created_at" label="提现时间">
          <template slot-scope="s">
            <span>{{s.row.created_at | format('MM-DD hh:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提现金额">
          <template slot-scope="s">
            <!-- <span class="price">{{s.row.total_amount-s.row.coupon_deduct_amount}}</span> -->
            <span class="price">{{s.row.total_amount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="s">
            <span class="paid">{{s.row.status_text}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="s">
            <!-- <router-link v-show="s.row.is_paid === 0" :to="{name: 'tour_pay', query: { orderNo: s.row.order_sn }}" class="pay_btn">支付</router-link> -->
            <!-- <router-link :to="{name: 'tour_order_detail', query: { order_sn: s.row.order_sn }}">详情</router-link> -->
            <el-popconfirm 
              class="delete"
              confirmButtonText='是的'
              cancelButtonText='不用了'
              icon="el-icon-info"
              iconColor="#66b1ff"
              title="确定提交审核吗？"
              @confirm="deleteAddress(s.row.id)">
              <el-button slot="reference" size="mini" type="primary">提交审核</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="search.page"
        @current-change="changePage"
        :hide-on-single-page="true"
        :total="total">
      </el-pagination>
    </div>
  </main>
</template>

<script>
import menus from '@components/menu';
import moment from 'moment';
import { mapState } from 'vuex';
import $tour from '@api/tour';
export default {
  components: {
    menus
  },
  data () {
    return {
      navIndex: 0,
      loading: true,
      nav: [
        { label: '全部' },
        { label: '待提现' },
        { label: '已提现' },
        { label: '审核中' }
      ],
      search: {
        page: 1,
        rows: 10
      },
      total: 0,
      list: [],
      ti:0
    }
  },
  async created () {
    this.getList();
  },
  filters: {
    format (val, desc = "MM月DD日") {
      return moment(val).format(desc);
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  methods: {
    changePage (page) {
      this.search = { ...this.search, page };
      this.getList();
    },
    getRequestData () {
      const {navIndex, nav} = this;
      let data = { ...this.search, status: nav[navIndex].label };
      return data;
    },
    async getList () {
      this.loading = true;
      const params = this.getRequestData();
      const { total, data } = await $tour.orderList(params);
      this.list = data;
      this.total = total;
      this.loading = false;
    },
    changeNavIndex (index) {
      if ( index === this.navIndex ) { return; }
      this.navIndex = index;
      this.search = { ...this.search, page: 1 };
      this.getList();
    },
    tix(){

      this.ti=1

    },
    re(){
      this.ti=0

    }
  }
}
</script>

<style scoped src="./list.css"></style>